import styled from 'styled-components';

export const ArrowLinkIconContainer = styled.div`
  display: inline-flex;
  margin-left: 1em;
  vertical-align: middle;

  &.open {
    transform: rotate(180deg);
  }
`;
